import { render, staticRenderFns } from "./feature-type-group.component.vue?vue&type=template&id=b8e79754&scoped=true&"
import script from "./feature-type-group.component.vue?vue&type=script&lang=js&"
export * from "./feature-type-group.component.vue?vue&type=script&lang=js&"
import style0 from "./feature-type-group.component.vue?vue&type=style&index=0&id=b8e79754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e79754",
  null
  
)

export default component.exports